import Immutable from 'immutable';

export interface RawGeoLocation {
  id?: string;
  center: Array<number>;
  // eslint-disable-next-line camelcase
  place_name?: string;
  bbox: Array<number>;
  text?: string;
  // eslint-disable-next-line camelcase
  matching_place_name?: string;
}

const defaultValues: RawGeoLocation = {
  id: '',
  center: [],
  // eslint-disable-next-line camelcase
  place_name: '',
  bbox: [],
  text: '',
  // eslint-disable-next-line camelcase
  matching_place_name: '',
};

export const GeoLocationFactory = Immutable.Record(
  defaultValues,
  'GeoLocation'
);

export class GeoLocation extends GeoLocationFactory {
  serialize(): RawGeoLocation {
    return this.toJS();
  }

  static deserialize(rawGeoLocation: RawGeoLocation): GeoLocation {
    return new GeoLocation(rawGeoLocation);
  }
}
